<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue'
import isEmpty from 'lodash/isEmpty'
import ModelChildRender from './child/ModelChild.vue'
import { useCustomization } from '@/hooks/useCustomization'
import { useEnhancer } from '@/app/enhancer'
import CardHeader from '@/components/ui/card/CardHeader.vue'
import { EventType, useEvents } from '@/hooks/useEvents'

export default defineComponent({
  name: 'GoModal',
  components: {
    CardHeader,
    ModelChildRender,
  },
  emits: ['back'],
  setup(_, { emit }) {
    const mode = ref('')
    const customization = useCustomization()
    const { storeFavorites } = useEnhancer()
    const eventBus = useEvents()

    const setMode = (type) => {
      mode.value = type
    }

    const handleBack = () => {
      mode.value = ''
    }

    const isDemoMode = computed(() => customization.getCurrentDemoMode.value)

    const renderList = computed(() => {
      return customization.getAllModels.value.filter(item =>
        item.value.includes(mode.value.toLowerCase()),
      )
    })

    const activeMode = (item) => {
      return (
        item.key
        === storeFavorites.selectedModel.value
          ?.split('_')
          ?.shift()
          ?.toLocaleUpperCase()
      )
    }

    const isCurrent = item =>
      item.value === storeFavorites.selectedModel?.value

    const selected = (item) => {
      if (isCurrent(item))
        return
      customization.setModelType(item)
      storeFavorites.setCurrentConfig('model', item)
      eventBus.emit(EventType.ZOOM_RESET)
    }

    // onMounted(() => {
    //   const model = storeFavorites.selectedModel
    //   if (isEmpty(model))
    //     return
    // })

    return {
      mode,
      isDemoMode,
      renderList,
      modelOptions: customization.getModelOptions,
      isCurrent,
      setMode,
      handleBack,
      selected,
      activeMode,
      handleClose: () => {
        emit('back')
      },
    }
  },
})
</script>

<template>
  <div v-if="!mode" class="animate_500">
    <CardHeader title="MODEL" hidden-left @close="handleClose" />
    <div class="row full-height items-center q-col-gutter-md q-px-md q-py-sm">
      <div
        v-for="item in modelOptions"
        :key="item.key"
        v-ripple
        class="col-6 cursor-pointer"
        @click="setMode(item.key)"
      >
        <q-card
          class="relative-position" :class="[activeMode(item) ? 'border' : '']"
        >
          <q-img
            style="height: 135px"
            :src="item.url"
            alt="image cover"
            :img-style="{ transform: 'scale(1)' }"
            no-spinner
            no-transition
            fetchpriority="high"
          >
            <div
              v-if="activeMode(item)"
              class="absolute-top-right bg-transparent"
              style="padding: 2px 4px"
            >
              <q-avatar
                class="shadow-3"
                color="secondary"
                text-color="white"
                size="sm"
              >
                <q-icon name="checked" size="16px" />
              </q-avatar>
            </div>
            <section
              class="
                absolute-center
                column
                full-height
                text-center
                text-dark
                bg-transparent
                q-py-sm
                justify-center
              "
            >
              <!-- :class="isDemoMode ? 'justify-center' : 'justify-between'" -->
              <!-- <q-item-label v-if="!isDemoMode"></q-item-label> -->
              <q-item-label :lines="1" class="text-body1 text-weight-bold">
                {{ item.key }}
              </q-item-label>
              <!-- hidden price -->
              <!-- <q-item-label v-if="!isDemoMode" :lines="1" class="text-body2 text-weight-bold">
                {{ $filters.currency(item.price) }}(税込)
              </q-item-label> -->
            </section>
          </q-img>
        </q-card>
      </div>
    </div>
  </div>
  <div v-else class="animate_500">
    <CardHeader :title="mode" @back="handleBack" @close="handleClose" />
    <q-virtual-scroll
      v-slot="{ item, index }"
      :items="renderList"
      virtual-scroll-horizontal
      class="q-px-md q-pb-sm"
    >
      <ModelChildRender
        :key="index"
        :item="item"
        :is-current="isCurrent(item)"
        @on-selected="selected(item)"
      />
    </q-virtual-scroll>
  </div>
</template>
